import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import { useLocalization } from '../contexts/LocalizationContext';

export default function NotFoundPage() {
  const location = useLocation();
  const { localize } = useLocalization();

  return (
    <Row>
      <Col>
        <div className='d-flex flex-column justify-content-center align-items-center'>
          <h1 className='display-4'>{localize('error.page.not.found')}</h1>
          <code className='text-secondary'>{location.pathname}</code>
        </div>
      </Col>
    </Row>
  );
}
